import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg height={height}
      width={width}
      {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 9.25518L13.9999 6.08537C13.9995 5.32851 13.9993 4.95008 13.8153 4.63279C13.6313 4.3155 13.3029 4.13021 12.6461 3.75963L9.296 1.86939C8.66253 1.51197 8.3458 1.33325 8 1.33325C7.6542 1.33325 7.33747 1.51197 6.704 1.86939L3.35387 3.75963C2.69708 4.13021 2.36869 4.3155 2.18467 4.63279C2.00064 4.95008 2.00046 5.32851 2.00009 6.08537L2 9.25518C2 11.8062 2 13.0817 2.78105 13.8741C3.5621 14.6666 4.81917 14.6666 7.33333 14.6666H8.66667C11.1808 14.6666 12.4379 14.6666 13.2189 13.8741C14 13.0817 14 11.8062 14 9.25518Z" stroke="#72808F" strokeLinecap="round" />
      <path d="M6.66659 8.66667H5.33325M10.6666 8.66667H9.33325M6.66659 6H5.33325M6.66659 11.3333H5.33325M10.6666 6H9.33325M10.6666 11.3333H9.33325" stroke="#72808F" strokeLinecap="round" />
    </svg>

  )
}

export default SvgComponent
